export const formsMenuTree = [
  {
    id: "reactive-maintenance",
    label: "Reactive & Maintenance",
    icon: "fa-solid fa-screwdriver-wrench",
    children: [
      {
        id: "south-eastern",
        label: "South Eastern",
        icon: "fa-solid fa-bolt",
        items: [
          { icon: "fa-solid fa-phone", label: "LSER Call Out", path: "/admin/lser-form" },
          { icon: "fa-solid fa-clipboard-check", label: "LSER PPM Daily", path: "/admin/lser-ppm-daily-checklist" },
          { icon: "fa-solid fa-exclamation-triangle", label: "LSER Additional Concerns Sheet", path: "/admin/additional-concerns" },
        ],
      },
      {
        id: "ukpn",
        label: "UKPN",
        icon: "fa-solid fa-hard-hat",
        items: [
          { icon: "fa-solid fa-file-lines", label: "UKPN PPM Report", path: "/admin/ppm-report" },
          { icon: "fa-solid fa-industry", label: "UKPN PPM Worksheet", path: "/admin/ukpn-ppm" },
          { icon: "fa-solid fa-industry", label: "UKPN Reactive Worksheet", path: "/admin/ukpn-reactive" },
          { icon: "fa-solid fa-exclamation-triangle", label: "SQE_PRO_019J Additional Concerns Worksheet", path: "/admin/ukpn-additional-concerns" },
        ],
      },
    ],
  },
  {
    id: "hseq",
    label: "HSEQ",
    icon: "fa-solid fa-shield-halved",
    items: [
      { icon: "fa-solid fa-clipboard-check", label: "POW Assessment", path: "/admin/pow-assessment" },
      { icon: "fa-solid fa-table-list", label: "Site Register", path: "/admin/site-register" },
      { icon: "fa-solid fa-person-hiking", label: "Work At Height", path: "/admin/work-at-height" },
      { icon: "fa-solid fa-check-double", label: "MEWP Checklist", path: "/admin/mewp-checklist" },
      { icon: "fa-solid fa-screwdriver-wrench", label: "SF-004-G Plant Issue Form", path: "/admin/sf-004-g-plant-issue-form" },
      { icon: "fa-solid fa-layer-group", label: "SF-004-I BLUE Tower Parts Checklist", path: "/admin/sf-004-i-blue-tower-parts-checklist" },
      { icon: "fa-solid fa-layer-group", label: "SF-004-J RED Tower Parts Checklist", path: "/admin/sf-004-j-red-tower-parts-checklist" },
      { icon: "fa-solid fa-industry", label: "UKPN MST", path: "/admin/ukpn-mst" },
      { icon: "fa-solid fa-industry", label: "TBS UKPN", path: "/admin/ukpn-tbs" },
      { icon: "fa-solid fa-building", label: "Pre-Fabricated", path: "/admin/pre-fabricated" },
      { icon: "fa-solid fa-exclamation-triangle", label: "Accident Report", path: "/admin/accident-report" },
      { icon: "fa-solid fa-shield-halved", label: "Asbestos Briefing", path: "/admin/asbestos-briefing" },
      { icon: "fa-solid fa-hand-paper", label: "Hand Arm Vibration Log", path: "/admin/hand-arm-vibration" },
      { icon: "fa-solid fa-file-signature", label: "SF-005 Refusal To Work Form", path: "/admin/refusal-to-work-form" },
      { icon: "fa-solid fa-hard-hat", label: "SF-006-B PPE Self Check Form", path: "/admin/ppe-self-check-form" },
      { icon: "fa-solid fa-file-signature", label: "SF-027-C Permit to Break Ground", path: "/admin/permit-to-break-ground" },
      { icon: "fa-solid fa-clipboard-list", label: "SF-015-B HSEQ Site Inspection", path: "/admin/hseq-site-inspection" },
      { icon: "fa-solid fa-train", label: "SF-015-C Rail HSEQ Site Inspection (2)", path: "/admin/rail-hseq-site-inspection" },
      { icon: "fa-solid fa-file-medical", label: "SF-003-A Injured Person Statement", path: "/admin/injured-person-statement" },
      { icon: "fa-solid fa-file-signature", label: "SF-003-B Witness Statement", path: "/admin/witness-statement" },
      { icon: "fa-solid fa-file-lines", label: "SF-003-C Incident Report", path: "/admin/incident-report-sf003c" },
      { icon: "fa-solid fa-comments", label: "SF-015-F Behavioural Exchange Form - Engineers", path: "/admin/behavioural-exchange-engineers" },
      { icon: "fa-solid fa-fire", label: "SF-029 Hot Works Permit", path: "/admin/hot-works-permit" },
    ],
  },
  {
    id: "general",
    label: "General",
    icon: "fa-solid fa-folder-open",
    items: [
      { icon: "fa-solid fa-table-list", label: "Daily Worksheet", path: "/admin/daily-worksheet" },
      // Hidden on client request (only one daily worksheet needed). The form, its
      // route and all existing records are kept intact — un-comment to show it again.
      // { icon: "fa-solid fa-table-list", label: "TTS Daily Worksheet", path: "/admin/ttsl-daily-worksheet" },
    ],
  },
  {
    id: "sf-009-electrical",
    label: "SF-009 Electrical",
    icon: "fa-solid fa-bolt",
    items: [
      { icon: "fa-solid fa-file-signature", label: "SF-009-A Certificate of Authorisation for Electrical Systems", path: "/admin/sf-009-a-certificate-electrical" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-B Electrical Isolation Certificate", path: "/admin/sf-009-b-electrical-isolation" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-C Site Permit Register", path: "/admin/sf-009-c-site-permit-register" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-D Electrical Permit to Work", path: "/admin/sf-009-d-electrical-permit-to-work" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-E Electrical Sanction to Test", path: "/admin/sf-009-e-electrical-sanction-to-test" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-F Limitation of Access", path: "/admin/sf-009-f-limitation-of-access" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-G Register of Competent Persons (Electrical)", path: "/admin/sf-009-g-register-of-competent-persons" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-H Electrical Audit Inspection Report", path: "/admin/sf-009-h-electrical-audit-inspection-report" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-I Switch Room Electrical Safety Log", path: "/admin/sf-009-i-switch-room-electrical-safety-log" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-J Risk Assessment Schedule", path: "/admin/sf-009-j-risk-assessment-schedule" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-K Risk Assessment Template", path: "/admin/sf-009-k-risk-assessment-template" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-L Appointment of Authorised Person Assessment", path: "/admin/sf-009-l-appointment-authorised-person-assessment" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-M Acceptance of LV Electrical Safety Rules", path: "/admin/sf-009-m-acceptance-lv-electrical-safety-rules" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-N Initial Site Electrical Safety Condition Report", path: "/admin/sf-009-n-initial-site-electrical-safety-condition-report" },
      { icon: "fa-solid fa-file-signature", label: "SF-009-O Weekly Small Plant Inspection Record", path: "/admin/sf-009-o-weekly-small-plant-inspection-record" },
    ],
  },
];

export function collectFormPaths(node) {
  const paths = [];
  if (node.items) {
    node.items.forEach((item) => {
      if (item.path) paths.push(item.path);
    });
  }
  if (node.children) {
    node.children.forEach((child) => {
      paths.push(...collectFormPaths(child));
    });
  }
  return paths;
}

export function getAllFormPaths() {
  return formsMenuTree.flatMap((category) => collectFormPaths(category));
}

export function getOpenGroupIdsForPath(pathname) {
  const openIds = new Set();
  formsMenuTree.forEach((category) => {
    if (category.items?.some((item) => item.path === pathname)) {
      openIds.add(category.id);
    }
    category.children?.forEach((child) => {
      if (child.items?.some((item) => item.path === pathname)) {
        openIds.add(category.id);
        openIds.add(`${category.id}:${child.id}`);
      }
    });
  });
  return openIds;
}

export function isFormPath(pathname) {
  return getAllFormPaths().includes(pathname);
}
